export default __webpack_public_path__ + "static/media/IftikharRasha-Resume.7241cc1e.pdf";